import React, { useState, useEffect } from "react";
import "../App.css";
import { getTokenInternal } from "./useToken";
import { useNavigate } from "react-router";
import Nav from "./Navigation.js";

const CreateItemForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    types: "",
    event: "",
    maps: "",
    maps_name: "",
    url: "",
    games_id: "", // Added games_id field to formData
  });

  const [token, setToken] = useState(null);
  const [typeOptions, setTypeOptions] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);
  const [mapsNameOptions, setMapsNameOptions] = useState([]);
  const [gamesNameOptions, setGamesNameOptions] = useState([]);
  const [mapsExclusiveOptions, setMapsExclusiveOptions] = useState([]);
  const [itemCreated, setItemCreated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const fetchedToken = await getTokenInternal();
        setToken(fetchedToken);
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    };

    const fetchDropdownOptions = async () => {
      try {
        const [typesResponse, eventsResponse, mapsResponse, mapsNameResponse, gamesResponse] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_HOST}/api/types`),
          fetch(`${process.env.REACT_APP_API_HOST}/api/events`),
          fetch(`${process.env.REACT_APP_API_HOST}/api/maps`),
          fetch(`${process.env.REACT_APP_API_HOST}/api/maps_name`),
          fetch(`${process.env.REACT_APP_API_HOST}/api/games`)
        ]);

        if (!typesResponse.ok || !eventsResponse.ok || !mapsResponse.ok || !mapsNameResponse.ok || !gamesResponse.ok) {
          throw new Error('Failed to fetch one or more resources');
        }

        setTypeOptions(await typesResponse.json());
        setEventOptions(await eventsResponse.json());
        setMapsExclusiveOptions(await mapsResponse.json());
        setMapsNameOptions(await mapsNameResponse.json());
        setGamesNameOptions(await gamesResponse.json());
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      }
    };

    fetchToken();
    fetchDropdownOptions();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!token) {
        console.error("Token is not available.");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/api/items/create`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setItemCreated(true);
        setTimeout(() => setItemCreated(false), 5000);
      } else {
        console.error("Failed to create item:", response.status);
        setItemCreated(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setItemCreated(false);
    }
  };

  useEffect(() => {
    if (
      token &&
      !["owner", "management", "helper"].includes(token.account.role)
    ) {
      navigate("/");
    }
  }, [token, navigate]);

  return (
    <div className="text-white">
      <Nav />
      {itemCreated && (
        <p className="text-green-500 text-center">Item created!</p>
      )}
      <form onSubmit={handleSubmit} className="max-w-md mx-auto my-8">
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Name:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            />
          </label>
        </div>
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Category:
            <select
              name="types"
              value={formData.types}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select a type
              </option>
              {typeOptions.map((type) => (
                <option key={type.id} value={type.name}>
                  {type.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Event:
            <select
              name="event"
              value={formData.event}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select an event
              </option>
              {eventOptions.map((event) => (
                <option key={event.id} value={event.name}>
                  {event.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Stamp type or Maps Exclusive:
            <select
              name="maps"
              value={formData.maps}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select a maps exclusive
              </option>
              {mapsExclusiveOptions.map((mapsExclusive) => (
                <option key={mapsExclusive.id} value={mapsExclusive.name}>
                  {mapsExclusive.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Maps Name:
            <select
              name="maps_name"
              value={formData.maps_name}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select a maps exclusive
              </option>
              {mapsNameOptions.map((mapsName) => (
                <option key={mapsName.id} value={mapsName.name}>
                  {mapsName.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Url:
            <input
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            />
          </label>
        </div>
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Game Name:
            <select
              name="games_id"
              value={formData.games_id}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select a game
              </option>
              {gamesNameOptions.map((game) => (
                <option key={game.id} value={game.id}>
                  {game.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="text-center">
          <button
            type="submit"
            className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-700"
          >
            Create Item
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateItemForm;
